var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "col-lg-12 col-sm-12 pt-3 bg-white",
      attrs: { id: "login" }
    },
    [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.login()
            }
          }
        },
        [
          _vm.error
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger",
                  model: {
                    value: _vm.error,
                    callback: function($$v) {
                      _vm.error = $$v
                    },
                    expression: "error"
                  }
                },
                [_vm._v(_vm._s(_vm.error))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.input.org_id,
                  expression: "input.org_id"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "org_id",
                id: "org_id",
                placeholder: "Org ID"
              },
              domProps: { value: _vm.input.org_id },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.input, "org_id", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.input.username,
                  expression: "input.username"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "username",
                id: "username",
                placeholder: "Username"
              },
              domProps: { value: _vm.input.username },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.input, "username", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.input.password,
                  expression: "input.password"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "password",
                id: "password",
                name: "password",
                placeholder: "Password"
              },
              domProps: { value: _vm.input.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.input, "password", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "login-btn btn btn-primary col-12",
              attrs: { type: "submit", role: "submit" }
            },
            [_vm._v("\n      Login\n    ")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "mt-4 mb-0 small text-muted text-center" }, [
            _vm._v("If your company doesn't have a subscription"),
            _c("br"),
            _c("a", { attrs: { href: this.$company.urlSignup } }, [
              _vm._v("click\n      here")
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26084dc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26084dc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = null
// module chunks = 